import { useNonce } from '#app/utils/nonce-provider.ts'

export function JsonLd({
	data,
}: {
	data: Record<string, unknown> | Array<Record<string, unknown>>
}) {
	const nonce = useNonce()
	return (
		<script
			type="application/ld+json"
			nonce={nonce}
			dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
		/>
	)
}
